import _ from 'lodash'
import {connect} from 'react-redux'

import {addLeg} from '../leg/leg.action'
import {appendDay, updateTripTitle, updateItinName, toggleBooking} from '../planner/planner.action'
import {initialItineraryLoad, setCommitMsg} from '../socket/socket.action'
import {ItineraryTop} from './itinerarytop.component'
import legUtil from '../util/leg.util'
import userUtil from '../util/user.util'

const mapStateToProps = (state) => {
    return {
        legs: state.getIn(['document', 'legs']),
        days: state.getIn(['document', 'properties', 'totalDays']),
        halfHidden: !_.isUndefined(legUtil.getActiveLeg(state)),
        itinerary: state.getIn(['initialData', 'itinerary']),
        tripName: state.getIn(['document', 'properties', 'tripTitle']),
        itinName: state.getIn(['document', 'properties', 'itinTitle']),
        isLunaTrip: state.getIn(['lunaTrip', 'isLunaTrip']),
        lunatrip: state.getIn(['lunaTrip', 'trip']),
        currentUser: userUtil.getCurrentUser(state),
        tripGuid: state.getIn(['document', 'properties', 'tripGuid']),
        itineraryGuid: state.getIn(['document', 'properties', 'itineraryGuid']),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onAddLeg: (startDay) => {
            dispatch(setCommitMsg('Added new leg'))
            dispatch(addLeg(startDay))
        },
        onAddDay: () => {
            dispatch(setCommitMsg('Added another day'))
            dispatch(appendDay())
        },
        onUpdateTripTitle: (tripName) => {
            dispatch(setCommitMsg('Changed trip title to ' + tripName))
            dispatch(updateTripTitle(tripName))
        },
        onUpdateItinName: (itinName) => {
            dispatch(setCommitMsg('Changed itinerary title to ' + itinName))
            dispatch(updateItinName(itinName))
        },
        onToggleBooking: () => {
            dispatch(toggleBooking())
        }
    }}

const ItineraryTopContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ItineraryTop)

export default ItineraryTopContainer
